import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import { ref } from 'vue';
import { trans, transChoice } from 'laravel-vue-i18n';
import DetailValue from '../../../Components/DetailValue.vue';
import { concatPlotsCodes, formatISODate } from '../../../Services/Utils';
import { useMitt } from '../../../Plugins/mitt';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const emitter = useMitt();
        const localData = ref(props.data);
        const edit = () => emitter.emit('open-leaves-data-form', localData.value);
        emitter.on('leaves-data-saved', (data) => (localData.value = data));
        const __returned__ = { emitter, props, localData, edit, get Button() { return Button; }, get trans() { return trans; }, get transChoice() { return transChoice; }, DetailValue, get concatPlotsCodes() { return concatPlotsCodes; }, get formatISODate() { return formatISODate; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
